import { forwardRef } from 'react';
import styled from 'styled-components';
import { getColorWithAlpha, Show } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { Filters } from '../components/filters/filters';
import { useLocationsFilter } from '../locations-filter-provider';
import { useAvailableFilters } from '../utils/use-available-filters';
import { DirectorySearch } from './directory-search';

export const DirectoryHeader = forwardRef<HTMLDivElement, {}>(
  function SidebarHeader(forwardingProps, forwardingRef) {
    const {
      backgroundColor,
      directoryHeading,
      directoryHeadingStyle,
      directoryShowSearch,
      textColor
    } = useSettings();

    const { currentFiltersStyle } = useLocationsFilter();

    const { availableFilters } = useAvailableFilters();

    const directoryShowFilters =
      currentFiltersStyle === 'sidePanel' && availableFilters.length > 0;

    const directoryShow =
      directoryHeading || directoryShowSearch || directoryShowFilters;

    if (!directoryShow) {
      return null;
    }

    return (
      <Container
        {...forwardingProps}
        _backgroundColor={backgroundColor}
        _color={textColor}
        ref={forwardingRef}
      >
        <Show when={!!directoryHeading}>
          <Typography
            textStyle={{ fontWeight: 'bold', ...directoryHeadingStyle }}
            color={textColor}
          >
            {directoryHeading}
          </Typography>
        </Show>

        <Show when={directoryShowSearch}>
          <DirectorySearch />
        </Show>

        <Show when={directoryShowFilters}>
          <Filters />
        </Show>
      </Container>
    );
  }
);

const Container = styled.div<{ _color: string; _backgroundColor: string }>`
  position: static;
  display: flex;
  flex-direction: column;
  gap: 16px;
  top: 0;
  z-index: 1;
  padding: 12px 12px 16px;
  background: ${({ _backgroundColor }) => _backgroundColor};
  border-bottom: 1px solid ${({ _color }) => getColorWithAlpha(_color, 0.1)};
  pointer-events: all;
`;
